import React from 'react';
import { Link } from 'react-router-dom';
import { quickSummaryItems, termsSections } from '../content/legal';
import { downloadLegalPdf } from '../utils/legalPdf';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_rgba(14,165,233,0.10),_transparent_26%),linear-gradient(180deg,_#f8fafc_0%,_#eef2ff_100%)]">
      <section className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-[0_24px_80px_-52px_rgba(15,23,42,0.45)] sm:p-8">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">LocalAlly Legal</p>
              <h1 className="mt-2 text-4xl font-semibold tracking-tight text-slate-950">Terms of Service</h1>
              <p className="mt-3 max-w-2xl text-sm leading-7 text-slate-600">
                Read this before using <span className="text-indigo-600 font-medium">Local</span><span className="text-emerald-600 font-medium">Ally</span>. These terms explain the platform role, location logic, payments, conduct requirements, and dispute handling.
              </p>
            </div>
            <button
              type="button"
              onClick={downloadLegalPdf}
              className="inline-flex items-center justify-center rounded-full bg-slate-950 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-800"
            >
              Download PDF
            </button>
          </div>

          <div className="mt-8 grid gap-4 md:grid-cols-3">
            {quickSummaryItems.map((item) => (
              <div key={item.title} className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4">
                <p className="text-sm font-semibold text-slate-950">{item.title}</p>
                <p className="mt-2 text-sm leading-6 text-slate-600">{item.body}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 space-y-8">
            {termsSections.map((section) => (
              <section key={section.title} className="rounded-[1.5rem] border border-slate-200 bg-white p-5">
                <h2 className="text-xl font-semibold text-slate-950">{section.title}</h2>
                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph} className="mt-3 text-sm leading-7 text-slate-600">
                    {paragraph}
                  </p>
                ))}
                {section.bullets && (
                  <div className="mt-4 space-y-3">
                    {section.bullets.map((bullet) => (
                      <div key={bullet} className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm leading-6 text-slate-700">
                        {bullet}
                      </div>
                    ))}
                  </div>
                )}
              </section>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/privacy"
              className="inline-flex items-center rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
            >
              Privacy Policy
            </Link>
            <Link
              to="/register"
              className="inline-flex items-center rounded-full bg-cyan-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-cyan-700"
            >
              Back to Signup
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
